export default "__VITE_ASSET__2c7d2242__"